export default "__VITE_ASSET__98581272__"